import {
  message,
  PageHeader,
  Spin,
  Select,
  Row,
  Col,
  Input,
  Space,
  Alert,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  cuentaMask,
  InputItem,
  ButtonItem,
  SwitchItem,
  ErrorItem,
  SelectInsumosItem,
  DatePickerItem,
  DynamicCardForm,
  TabbedDynamicTable,
  ModalItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
} from "../../../../Components/Items";
import { PlusOutlined, ContainerOutlined, CommentOutlined, DeleteOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import AgregarMarbetes from "../../Marbetes/AgregarMarbetes/AgregarMarbetes";
import AgregarLotes from "../../LotesCaducidades/AgregarLotes/AgregarLotes";
import SelectUbicacionesProyectoItem from "../../../../Components/SelectUbicacionesProyectoItem";
import moment from "moment";

const { Option } = Select;

class EditarOrdenAgregarInventario extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    todasUbicaciones: [],
    ubicacionesProyectoId: undefined,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    modalAgregarCuentaContable: false,
    modalAgregarMarbetes: false,
    modalAgregarMarbetesIndex: null,
    modalAgregarMarbetesMarbetes: null,
    conLotesYCaducidades: false,
    estadoOrden: null,
    cantidadInsumosOriginales: 0,
    modalConfirmarEdicionConfirmada: false,
    valoresPendientes: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "agregarInventario/datosOrdenAgregarInventario",
        {
          empresaId: this.props.empresaId,
          ordenId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          return;
        }
        if (res.data.estado === 0) {
          message.warning("Esta orden está cancelada y no se puede editar");
          this.atras();
          return;
        }

        this.setState({
          todasInsumos: res.data.insumosCatalogo || [],
          estadoOrden: res.data.estado,
          conLotesYCaducidades: res.data.conLotesYCaducidades,
          cantidadInsumosOriginales: (res.data.insumos || []).length,
        });

        this.formRef.current.setFieldsValue({
          proyectoId: res.data.proyectoId,
          referencia: res.data.referencia,
          contabilizar: res.data.contabilizar,
          cuentaAbonoId: res.data.cuentaAbonoId,
          conLotesYCaducidades: res.data.conLotesYCaducidades,
          insumos: (res.data.insumos || []).map((value) => ({
            ...value,
            caducidad: value.caducidad ? moment(value.caducidad) : null,
          })),
        });

        if (this.props.moduloWms && res.data.proyectoId) {
          this.cargarUbicacionesDelAlmacen(res.data.proyectoId);
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }

  cargarUbicacionesDelAlmacen = async (proyectoId, forzar = false) => {
    if (!this.props.moduloWms || !proyectoId) {
      this.setState({ todasUbicaciones: [], ubicacionesProyectoId: undefined });
      return [];
    }
    if (!forzar && this.state.ubicacionesProyectoId === proyectoId) {
      return this.state.todasUbicaciones;
    }
    try {
      const res = await axios.post(
        "ubicacionProyecto/selectUbicacionesProyecto",
        { empresaId: this.props.empresaId, proyectoId, estado: 1 },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const ubicaciones = res.data.ubicaciones || [];
        this.setState({ todasUbicaciones: ubicaciones, ubicacionesProyectoId: proyectoId });
        return ubicaciones;
      }
    } catch (err) {
      console.error(err);
    }
    return [];
  };

  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (!values.insumos || values.insumos?.length === 0)
      return message.error("Agregue insumos para poder guardar la orden");

    if (this.state.estadoOrden === 3) {
      this.setState({ valoresPendientes: values, modalConfirmarEdicionConfirmada: true });
      return;
    }

    this.guardarEdicion(values);
  }
  guardarEdicion(values) {
    this.setState({ loading: true, modalConfirmarEdicionConfirmada: false });
    axios
      .post(
        "agregarInventario/editarOrdenAgregarInventario",
        {
          ...values,
          ordenId: this.props.location.state.id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false, valoresPendientes: null });
        if (res.data.success === 2) {
          message.success("Se ha actualizado la orden");
          if (res.data.resumen) {
            NotificacionPolizas(res.data.resumen.polizaNueva || []);
            NotificacionMovimientosInventario(res.data.resumen.movimientoNuevo || []);
          }
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se puede guardar la orden");
        } else {
          message.error("Hubo un error y la orden no se guardo");
        }
      });
  }

  async onChangeInsumo(value, index, insumoEncontrado) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    const insumoId = arrayValue[index].insumoId;
    let insumo;
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find((i) => i._id === insumo._id);
      if (!yaExiste) {
        await this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, insumo] }));
      }
    } else {
      insumo = this.state.todasInsumos.find((valueInsumos) => valueInsumos._id === insumoId);
    }
    if (!insumo) return;
    if (this.formRef.current.getFieldValue("contabilizar")) {
      arrayValue[index].costo = insumo.costo;
      this.formRef.current.setFieldsValue({ insumos: arrayValue });
    }
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

  abrirAgregarMarbetes(value, marbetes) {
    this.setState({
      modalAgregarMarbetes: true,
      modalAgregarMarbetesIndex: value,
      modalAgregarMarbetesMarbetes: marbetes,
    });
  }
  cerrarAgregarMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarMarbetesIndex].marbetes = value;
    this.formRef.current.setFieldsValue({ insumos });
    this.setState({
      modalAgregarMarbetes: false,
      modalAgregarMarbetesIndex: null,
      modalAgregarMarbetesMarbetes: null,
    });
  }

  abrirAgregarLotes(value, lotes, insumoId, descripcion, vehiculo) {
    this.setState({
      modalAgregarLotes: true,
      modalAgregarLotesIndex: value,
      modalAgregarLotesLotes: lotes,
      modalAgregarLotesInsumoId: insumoId,
      modalAgregarLotesTipoEspecie: descripcion || "",
      modalAgregarLotesVehiculo: vehiculo,
    });
  }
  cerrarAgregarLotes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarLotesIndex].lotes = value;
    this.formRef.current.setFieldsValue({ insumos });
    this.setState({
      modalAgregarLotes: false,
      modalAgregarLotesIndex: null,
      modalAgregarLotesLotes: null,
      modalAgregarLotesInsumoId: null,
      modalAgregarLotesTipoEspecie: null,
    });
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    const conLotesYCaducidades = this.state.conLotesYCaducidades;

    const insumosColumns = conLotesYCaducidades
      ? [
          { title: "Clave", width: "5%" },
          { title: "Insumo", width: "25%" },
          { title: "Unidad", width: "5%" },
          { title: "Costo", width: "12%" },
          { title: "Cantidad", width: "12%" },
          ...(this.props.moduloWms ? [{ title: "Ubicación", width: "10%" }] : []),
          { title: "Lote", width: "13%" },
          { title: "Caducidad", width: "13%" },
          { title: "Acción", width: "15%" },
        ]
      : [
          { title: "Clave", width: "6%" },
          { title: "Insumo", width: "38%" },
          { title: "Unidad", width: "6%" },
          { title: "Costo", width: "15%" },
          { title: "Cantidad", width: "15%" },
          ...(this.props.moduloWms ? [{ title: "Ubicación", width: "12%" }] : []),
          { title: "Acción", width: "15%" },
        ];

    const allTabs = [
      {
        key: "insumos",
        label: "Insumos",
        listName: "insumos",
        columns: insumosColumns,
        renderRow: ({ key, name, restField, arrayKey, remove }) => (
          <FormItem key={key} noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const row = (getFieldValue("insumos") || [])[arrayKey];
              const insumo = this.state.todasInsumos?.find((i) => i._id === row?.insumoId);
              // Una vez confirmada la orden, los renglones que ya se dieron
              // de alta quedan congelados: solo se pueden agregar renglones
              // nuevos (los que se agreguen después de este punto).
              const esRenglonCongelado = this.state.estadoOrden === 3 && arrayKey < this.state.cantidadInsumosOriginales;
              return (
                <tr id={`insumo-row-${arrayKey}`}>
                  <td className="td-border">
                    <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                      {insumo?.clave || "-"}
                    </div>
                  </td>
                  <td className="td-border">
                    <FormItem {...restField} name={[name, "insumoId"]} fieldKey={[arrayKey, "insumoId"]} required noStyle>
                      <SelectInsumosItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        sinBorde
                        ocultarCodigoYUnidad
                        dropdownMatchSelectWidth={600}
                        width="100%"
                        placeholder="Insumo"
                        tiposInsumos="inventariables"
                        disabled={esRenglonCongelado}
                        onChange={(value, insumoEncontrado) => this.onChangeInsumo(value, arrayKey, insumoEncontrado)}
                        insumoPreCargado={insumo}
                      />
                    </FormItem>
                  </td>
                  <td className="td-border">
                    <div style={{ fontSize: "14px", textAlign: "center" }}>{insumo?.unidad || "-"}</div>
                  </td>
                  <td className="td-border">
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const contabilizar = getFieldValue("contabilizar");
                        return (
                          <FormItem {...restField} name={[name, "costo"]} fieldKey={[arrayKey, "costo"]} numberCero noStyle required initialValue={0}>
                            <InputNumberItem disabled={!contabilizar || esRenglonCongelado} sinBorde />
                          </FormItem>
                        );
                      }}
                    </FormItem>
                  </td>
                  <td className="td-border">
                    <FormItem {...restField} name={[name, "cantidad"]} fieldKey={[arrayKey, "cantidad"]} number noStyle required initialValue={undefined}>
                      <InputNumberItem sinBorde disabled={esRenglonCongelado} />
                    </FormItem>
                  </td>
                  {this.props.moduloWms && (
                    <td className="td-border">
                      <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => (
                          <FormItem {...restField} name={[name, "ubicacionId"]} fieldKey={[arrayKey, "ubicacionId"]} noStyle>
                            <SelectUbicacionesProyectoItem
                              empresaId={this.props.empresaId}
                              headersToken={this.props.headersToken}
                              proyectoId={getFieldValue("proyectoId")}
                              opciones={this.state.todasUbicaciones.length > 0 ? this.state.todasUbicaciones : undefined}
                              width="100%"
                              disabled={esRenglonCongelado}
                            />
                          </FormItem>
                        )}
                      </FormItem>
                    </td>
                  )}
                  {conLotesYCaducidades && (
                    insumo?.lotesCaducidades ? (
                      <>
                        <td className="td-border">
                          <FormItem {...restField} name={[name, "lote"]} fieldKey={[arrayKey, "lote"]} noStyle required>
                            <InputItem placeholder="Lote" disabled={esRenglonCongelado} />
                          </FormItem>
                        </td>
                        <td className="td-border">
                          <FormItem {...restField} name={[name, "caducidad"]} fieldKey={[arrayKey, "caducidad"]} noStyle>
                            <DatePickerItem placeholder="Caducidad" style={{ width: "100%" }} disabled={esRenglonCongelado} />
                          </FormItem>
                        </td>
                      </>
                    ) : (
                      <td className="td-border" colSpan={2}>No aplica lotes o caducidades</td>
                    )
                  )}
                  <td className="td-border">
                    <div className="acciones-container">
                      {esRenglonCongelado ? null : (
                        <Space style={{ width: "100%", gap: 5, justifyContent: "center" }}>
                          {insumo?.marbetes && (
                            <Tooltip title="Agregar Marbetes" placement="top" overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                              <ButtonItem
                                type="primary"
                                size="small"
                                cyan2
                                icon={<CommentOutlined />}
                                onClick={() => this.abrirAgregarMarbetes(arrayKey, row?.marbetes)}
                              >
                                Marbetes
                              </ButtonItem>
                            </Tooltip>
                          )}
                          {insumo?.lotesCaducidades && !conLotesYCaducidades && (
                            <Tooltip title="Lotes" placement="top" overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                              <ButtonItem
                                type="primary"
                                size="small"
                                amarillo2
                                icon={<ContainerOutlined />}
                                onClick={() => this.abrirAgregarLotes(arrayKey, row?.lotes, insumo?._id, insumo?.descripcion, insumo?.vehiculo)}
                              />
                            </Tooltip>
                          )}
                          <ButtonItem rojo2 icon={<DeleteOutlined />} onClick={() => remove(name)} size="small" lessTime />
                        </Space>
                      )}
                    </div>
                  </td>
                </tr>
              );
            }}
          </FormItem>
        ),
        renderFooter: ({ add, fields }) => (
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const proyecto = getFieldValue("proyectoId");
              const contabilizar = getFieldValue("contabilizar");
              const cuentaAbonoId = getFieldValue("cuentaAbonoId");
              return (
                <FormItem noStyle>
                  <div style={{ marginBottom: 6, marginTop: 6 }}>
                    <ButtonItem
                      type="dashed"
                      hotkey="alt+a"
                      cyan
                      block
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        justifySelf: fields.length > 0 ? "left" : null,
                        width: fields.length > 0 ? "auto" : null,
                      }}
                      onClick={() => {
                        if (contabilizar) {
                          if (proyecto && cuentaAbonoId) {
                            add();
                          } else {
                            message.info("Agregue los datos primero");
                          }
                        } else if (proyecto) {
                          add();
                        } else {
                          message.info("Agregue los datos primero");
                        }
                      }}
                      icon={<PlusOutlined />}
                    >
                      Agregar Campo
                    </ButtonItem>
                  </div>
                </FormItem>
              );
            }}
          </FormItem>
        ),
      },
    ];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Editar Orden - Agregar Inventario"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        {this.state.estadoOrden === 3 &&
          <Alert
            style={{ marginBottom: 12 }}
            type="warning"
            showIcon
            message="Esta orden ya fue confirmada"
            description="Los insumos que ya se dieron de alta quedan congelados: no se pueden editar ni eliminar. Solo puedes agregar insumos nuevos, que generarán una póliza (si aplica) y un movimiento de inventario adicionales. Hazlo con cuidado."
          />
        }
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="editarAgregarInventario"
              layout
              bottom={
                <div className="general-form-action-buttons">
                  <ButtonItem type="primary" htmlType="submit" hotkey="shift+a" cyanB>
                    Guardar
                  </ButtonItem>
                </div>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos?.length !== curr.insumos?.length}>
                {({ getFieldValue }) => {
                  const insumos = getFieldValue("insumos");
                  const disabled = insumos && insumos.length > 0 ? true : false;
                  return (
                    <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
                      <Col xs={24} xl={24}>
                        <DynamicCardForm title="DATOS GENERALES" style={{ margin: 0, height: "100%" }}>
                          <Row>
                            <Col span={12}>
                              <FormItem label="Proyecto" name="proyectoId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                                <SelectItem
                                  disabled={disabled}
                                  placeholder="Proyecto"
                                  onChange={(value) => this.cargarUbicacionesDelAlmacen(value)}
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem name="referencia" label="Referencia" margin pattern labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                                <InputItem placeholder="Referencia" />
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              <FormItem
                                label="Contabilizar"
                                name="contabilizar"
                                margin
                                valuePropName="checked"
                                labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}
                              >
                                <SwitchItem disabled={disabled || !this.props.permisoContabilizarAgregarInventario} />
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                  const contabilizar = getFieldValue("contabilizar");
                                  if (contabilizar) {
                                    return (
                                      <FormItem label="Cuenta Abono" margin labelCol={{ span: 6 }} wrapperCol={{ span: 15 }}>
                                        <Input.Group compact>
                                          <FormItem name="cuentaAbonoId" required noStyle>
                                            <SelectItem disabled={disabled} placeholder="Cuenta Abono" width="80%">
                                              {this.state.objetoCuentaContable}
                                            </SelectItem>
                                          </FormItem>
                                          <ButtonItem
                                            icon={<PlusOutlined />}
                                            style={{ width: "12%", marginLeft: 5 }}
                                            disabled={disabled}
                                            onClick={this.abrirAgregarCuentaContable.bind(this)}
                                          />
                                        </Input.Group>
                                      </FormItem>
                                    );
                                  }
                                }}
                              </FormItem>
                            </Col>
                          </Row>
                          {this.props.lotesCaducidades && (
                            <Row>
                              <Col span={12}>
                                <FormItem
                                  label="Lotes"
                                  name="conLotesYCaducidades"
                                  margin
                                  valuePropName="checked"
                                  tooltip="Si los insumos que agregaras tienen lotes o caducidades, activa esta opción para poder agregarlos por fila"
                                  labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}
                                >
                                  <SwitchItem disabled={disabled} onChange={(e) => this.setState({ conLotesYCaducidades: e })} />
                                </FormItem>
                              </Col>
                            </Row>
                          )}
                        </DynamicCardForm>
                      </Col>
                    </Row>
                  );
                }}
              </FormItem>
              <div style={{ marginTop: 20 }}>
                <TabbedDynamicTable formInstance={this.formRef} defaultActiveKey="insumos" isMobile={isMobile} tabs={allTabs} />
              </div>
            </Form>
          </Spin>
        </div>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <AgregarMarbetes
          visible={this.state.modalAgregarMarbetes}
          cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
          marbetes={this.state.modalAgregarMarbetesMarbetes}
        />
        <AgregarLotes
          visible={this.state.modalAgregarLotes}
          cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
          lotes={this.state.modalAgregarLotesLotes}
          insumoId={this.state.modalAgregarLotesInsumoId}
          tipoEspecie={this.state.modalAgregarLotesTipoEspecie}
          vehiculo={this.state.modalAgregarLotesVehiculo}
        />
        <ModalItem
          title="Confirmar edición de orden ya confirmada"
          visible={this.state.modalConfirmarEdicionConfirmada}
          onCancel={() => this.setState({ modalConfirmarEdicionConfirmada: false, valoresPendientes: null })}
          onOk={() => this.guardarEdicion(this.state.valoresPendientes)}
          spinning={false}
          footer
        >
          <p>Al guardar estos cambios el sistema:</p>
          <ul>
            <li>No tocará los insumos que ya se dieron de alta — quedan tal cual.</li>
            <li>Agregará al inventario únicamente los insumos nuevos que agregaste.</li>
            <li>Generará una póliza (si aplica) y un movimiento de inventario adicionales, solo con esos insumos nuevos.</li>
          </ul>
          <p style={{ textAlign: "center", fontWeight: "bold" }}>¿Seguro que quieres continuar?</p>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    lotesCaducidades: state.empresa.lotesCaducidades,
    moduloWms: state.empresa.moduloWms,
    permisoContabilizarAgregarInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "6526099a3d4cd64267a901dd"
      )?.activado,
  };
};

export default connect(mapStateToProps)(EditarOrdenAgregarInventario);
